import { useState } from 'react'
import { useTraversal } from '@guillotinaweb/react-gmi'

export function usePatchLanding() {
  const [loading, setLoading] = useState(false)
  const Ctx = useTraversal()

  async function patch(data) {
    setLoading(true)
    const newContext = { ...Ctx.context, ...data }
    const resp = await Ctx.client.patch(Ctx.path, {
      description: newContext.description,
      for_langs: newContext.forLangs,
      image_src: newContext.image_src,
      sections: newContext.sections,
      slug: newContext.slug,
      template: newContext.template,
      title: newContext.title,
      labels: newContext.labels,
      post_author: newContext.postAuthor,
      publish_date: newContext.publishDate,
      searchable: newContext.searchable,
    })
    if (resp.status === 204) {
      Ctx.flash('Landing updated', 'success')
      Ctx.refresh({ transparent: true })
      setLoading(false)
      return true
    }

    let message = 'Error updating the landing'
    try {
      const body = await resp.json()
      message = body.message || body.reason || message
    } catch (e) {
      // The response body is not JSON.
    }
    Ctx.flash(message, 'danger')
    setLoading(false)
    return false
  }

  return [loading, patch]
}
